import React from 'react';
import { track_download } from '../Script/RetailerFitGuide_Tracking.js';

const RetailerFitGuide_Downloads = ({ title, files }) => {
    if (!files?.length > 0) return null;

    return (
        <div className="retailerFitGuide_Downloads">
            {title && <h2 className="heading3 mb-7">{title}</h2>}
            {files.map((file, index) =>
                <a onClick={() => track_download(file.downloadId)} key={index} href={file.url} target="_blank" rel="noopener noreferrer" className="paragraph--s mb-5 d-flex align-items-center">
                    <i className="le-icon-file-text me-3"></i>
                    {file.fileName}
                </a>
            )}
        </div>
    );
};

export default RetailerFitGuide_Downloads;